import MaterialIcon from '@/components/atom/MaterialIcon';

interface Props {
  navigateToFindPharmacyScreen: () => void;
}

const FindPharmacyFeatureSnippet = ({ navigateToFindPharmacyScreen }: Props) => {
  return (
    <div className={'flex justify-between gap-[16px] py-[16px]'} onClick={navigateToFindPharmacyScreen}>
      <div className={'flex items-center gap-[16px]'}>
        <img
          alt={'dietInjectionSnippetIcon'}
          src={'/images/search/findPharmacySnippetIcon.png'}
          className={'h-[40px] w-[40px]'}
        />
        <div className={'flex flex-col gap-[2px]'}>
          <span className={'typography-ui-17sb text-gray-600'}>약국 찾기</span>
          <span className={'typography-ui-13r text-gray-400'}>가까운 약국 찾기부터 약 값 비교까지</span>
        </div>
      </div>
      <MaterialIcon name={'keyboard_arrow_right'} />
    </div>
  );
};

export default FindPharmacyFeatureSnippet;
